// //////////////////////////////////////////////////////////////////////////////////
// CONSTANTS
// //////////////////////////////////////////////////////////////////////////////////

export const SET_PARAM = 'pp.admin/filter/SET_PARAM'
export const CLEAR_PARAMS = 'pp.admin/filter/CLEAR_PARAMS'
// //////////////////////////////////////////////////////////////////////////////////
// REDUCER
// //////////////////////////////////////////////////////////////////////////////////
const initialState = { params: {} }

export default function reducer(state = initialState, action) {
	let params
	switch (action.type) {
		case SET_PARAM:
			params = { ...state.params, ...action.payload }
			return { ...state, params }

		case CLEAR_PARAMS:
			return { ...state, params: {} }

		default:
			return state
	}
}
